export { default } from "./entry-point";
